module.exports = (__webpack_require__(0))(72);


//////////////////
// WEBPACK FOOTER
// delegated ./src/views/body/UserView.js from dll-reference girder_lib
// module id = 38
// module chunks = 0